import { Grid } from '@mui/material'
import { Typography } from '@refera/ui-web'
import React from 'react'
import useStyles from './styles'
import { formatDate } from '_/utils/helpers'

const WEEKDAYS = [
  'DOMINGO',
  'SEGUNDA-FEIRA',
  'TERÇA-FEIRA',
  'QUARTA-FEIRA',
  'QUINTA-FEIRA',
  'SEXTA-FEIRA',
  'SÁBADO',
]

const LogDate = ({ data }) => {
  const styles = useStyles()

  const formattedDate = `${WEEKDAYS[new Date(data).getDay()]}, ${formatDate(data)}`

  return (
    <Grid className={styles.container}>
      <Typography className={styles.dateText}>{formattedDate}</Typography>
    </Grid>
  )
}

export default LogDate
